// Inspired by Google Closure:
// http://closure-library.googlecode.com/svn/docs/
// closure_goog_array_array.js.html#goog.array.clear

"use strict";

var value = require("../../object/valid-value");

module.exports = function () {
	value(this).length = 0;
	return this;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/array/#/clear.js
// module id = 1130
// module chunks = 0